import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=44fff512&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=44fff512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fff512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44fff512')) {
      api.createRecord('44fff512', component.options)
    } else {
      api.reload('44fff512', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=44fff512&scoped=true&", function () {
      api.rerender('44fff512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KDEMTyoqyjeG/JS/comp/SearchFilterTokens.vue"
export default component.exports